import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const SendCoinHistory = () => {
  const [rechargeHistory, setRechargeHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const coinData = sessionStorage.getItem("coin");
  const coinDetails = JSON.parse(coinData);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePrevPage = () => setCurrentPage((prev) => prev - 1);
  const handleNextPage = () => setCurrentPage((prev) => prev + 1);
  const handleChangeItemsPerPage = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const fetchRechargeHistory = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: coinDetails.uniqueId,
        page: currentPage,
        limit: itemsPerPage,
        startDate: startDate ? `${startDate}T00:00:00` : undefined,
        endDate: endDate ? `${endDate}T23:59:59` : undefined,
      };

      const data = await fetch(
        `${process.env.REACT_APP_BASEURL3}/coin/recharge/history?page=${currentPage}&limit=${itemsPerPage}`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const response = await data.json();
      setRechargeHistory(response.history || []);
      setTotalItems(response.total || 0);
      setTotalAmount(response.totalAmount || 0);
      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const fetchSearchRechargeHistory = async () => {
    try {
      setLoading(true);
      const url = new URL(`${process.env.REACT_APP_BASEURL1}/coin/recharge/searchsendCoinHistory`);
      url.searchParams.append("userId", coinDetails.uniqueId);
      url.searchParams.append("search", search);
      if (startDate) url.searchParams.append("startDate", `${startDate}T00:00:00`);
      if (endDate) url.searchParams.append("endDate", `${endDate}T23:59:59`);

      const res = await fetch(url.toString(), { method: "GET" });
      const response = await res.json();

      setRechargeHistory(response.history || []);
      setTotalItems(response.total || 0);
      setTotalAmount(response.totalAmount || 0);
      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const applyFilter = () => {
    setCurrentPage(1); // Reset to first page
    if (search.trim() !== "") {
      fetchSearchRechargeHistory();
    } else {
      fetchRechargeHistory();
    }
  };

  useEffect(() => {
    if (!coinDetails) {
      window.location.href = "/coin";
    } else {
      applyFilter(); // load on first mount
    }
  }, [currentPage, itemsPerPage]);

  return (
    <>
      <section className="content-header">
        <h1>Coin History</h1>
      </section>

      <section className="content row">
        <div className="col-xs-12" style={{ marginBottom: "20px" }}>
          <div className="row">
            <div className="col-xs-3">
              <label>Start Date</label>
              <input
                type="date"
                value={startDate}
                className="form-control"
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-xs-3">
              <label>End Date</label>
              <input
                type="date"
                value={endDate}
                className="form-control"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-xs-3">
              <label>Search Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-xs-3">
              <label>&nbsp;</label>
              <button className="btn btn-primary form-control" onClick={applyFilter}>
                Apply Filter
              </button>
            </div>
          </div>
        </div>

        <div className="col-xs-12" style={{ marginBottom: "15px" }}>
          <div className="row">
            <div className="col-xs-6 text-left">
              <b>Total Entries:</b> {totalItems}
            </div>
            <div className="col-xs-6 text-right">
              <b>Total Amount:</b> {totalAmount}
            </div>
          </div>
        </div>

        <div className="pagination-options col-xs-6">
          <select
            className="form-control pagination-select"
            value={itemsPerPage}
            onChange={handleChangeItemsPerPage}
          >
            <option value="10">10 per page</option>
            <option value="50">50 per page</option>
            <option value="100">100 per page</option>
            <option value="1000">1000 per page</option>
          </select>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>User</th>
                      <th>Coin</th>
                      <th>Date/Time</th>
                    </tr>
                  </thead>
                  {loading ? (
                    <tbody>
                      <tr>
                        <td colSpan="4">Loading...</td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {Array.isArray(rechargeHistory) &&
                        rechargeHistory
                          .slice(indexOfFirstItem, indexOfLastItem)
                          .map((item, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{item?.userId}</td>
                              <td>
                                <label className="label label-success">{item?.coin}</label>
                              </td>
                              <td>{new Date(item?.createdAt).toLocaleString()}</td>
                            </tr>
                          ))}
                    </tbody>
                  )}
                </table>

                <div className="pagination-container">
                  <button
                    className="btn btn-default"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                  <div className="total-entries" style={{ float: "right", marginTop: "20px" }}>
                    Total entries: <b>{totalItems}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SendCoinHistory;
